const Option = require('app/components/checkout/steps/payment/Option')
const CvrField = require('app/components/fields/CVR')
const EanField = require('app/components/fields/EAN')
const Trans = require('app/components/trans/Trans')

class PublicInvoiceOption extends Option {
  renderContents () {
    if (!this.state.selected) {
      return
    }

    return (
      <form>
        <div className='inputs'>
          <div className='field required'>
            <label htmlFor='companyInput'><Trans>Firmanavn/Organisation</Trans></label>
            <input
              defaultValue={this.value('client.company', '')} type='text'
              required
              id='companyInput' name='company'
            />
          </div>

          <div className='field required'>
            <label htmlFor='cvrInput'><Trans>CVR Nr</Trans></label>
            <CvrField
              defaultValue={this.value('client.cvr', '')} type='text'
              required
              id='cvrInput' name='cvr'
            />
          </div>

          <div className='field required'>
            <label htmlFor='eanInput'><Trans>EAN Nr</Trans></label>
            <EanField
              defaultValue={this.value('client.ean', '')} type='text'
              id='eanInput' name='ean'
              required
            />
          </div>

          <div className='field'>
            <label htmlFor='requisitionInput'><Trans>Mærke til fakturaen</Trans></label>
            <input
              defaultValue={this.value('client.requisition', '')} type='text'
              id='requisitionInput' name='requisition'
              maxLength={50} required
            />
          </div>
        </div>
      </form>
    )
  }
}

module.exports = PublicInvoiceOption
